/* eslint react/jsx-key: off */
import {
    List,
    Datagrid,
    TextField,
    DateField,
    FunctionField,
    useRecordContext,
    ReferenceField,
    ReferenceInput,
    SelectInput,
    TextInput,
} from "react-admin";
import {
    Box,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

const ProjectChip = () => {
    const record = useRecordContext();
    if (!record) {
        return null;
    }
    return (
        <Chip
            label={record.name}
            size="small"
            sx={{
                backgroundColor: record.color ? `${record.color}30` : undefined,
                border: record.color ? `1px solid ${record.color}` : undefined,
            }}
        />
    );
};

const SampleListPanel = () => {
    const record = useRecordContext();
    if (!record) {
        return null;
    }
    const samples = (record.channels ?? [])
        .filter(channel => (channel.integral_results ?? []).length > 0)
        .map(channel => ({
            channel: channel.channel_name,
            samples: (channel.integral_results ?? [])
                .map(integral => integral.sample_name)
                .filter(Boolean)
                .join(', '),
        }))
        .sort((a, b) => a.channel.localeCompare(b.channel));

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="subtitle2" gutterBottom>Samples by channel</Typography>
            <Table size="small" sx={{ maxWidth: 640 }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Channel</TableCell>
                        <TableCell>Samples</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {samples.map(sample => (
                        <TableRow key={sample.channel}>
                            <TableCell>{sample.channel}</TableCell>
                            <TableCell>{sample.samples}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}

const instrumentFilters = [
    <TextInput source="name" label="Search name" alwaysOn />,
    <ReferenceInput source="project_id" reference="projects" alwaysOn>
        <SelectInput label="Project" optionText="name" />
    </ReferenceInput>,
];

export const InstrumentList = () => {
    const channelSamples = (record) => {
        // For each channel, get the sample for each integral result and return the total number
        let totalSamples = 0;
        (record.channels ?? []).forEach(channel => {
            totalSamples += (channel.integral_results ?? []).length;
        });
        return totalSamples;
    }

    return (
        <List
            storeKey={false}
            filters={instrumentFilters}
            sort={{ field: 'last_updated', order: 'DESC' }}
        >
            <Datagrid
                rowClick="show"
                expand={<SampleListPanel />}
                isRowExpandable={row => (row.channels ?? []).some(channel => (channel.integral_results ?? []).length > 0)}
            >
                <TextField source="filename" sortable={false} />
                <TextField source="name" />
                <TextField source="description" sortable={false} />
                <ReferenceField
                    source="project_id"
                    reference="projects"
                    link="show"
                    label="Project"
                    sortable={false}
                >
                    <ProjectChip />
                </ReferenceField>
                <DateField source="date" label="Measured" sortable={false} />
                <DateField source="last_updated" showTime />
                <FunctionField label="Channels (filtered/total)" sortable={false} render={record => `${record.channel_qty_filled}/${(record.channels ?? []).length}`} />
                <FunctionField label="Total samples" sortable={false} render={channelSamples} />
            </Datagrid>
        </List >
    );
};

export default InstrumentList;
